import React from 'react';
import styled from 'styled-components';
import SectionTitle from '@flow/scenes/home/components/section-title/SectionTitle';
import em from 'polished/lib/helpers/em';
import SimpleCarousel from '@flow/components/carousel/SimpleCarousel';

const Carousel = styled.div`
  ul.slick-dots {
    margin: 6em 0;
  }
`;

const ReviewContent = styled.div`
  text-align: center;
  max-width: 83em;
  margin: auto;
`;

const ReviewText = styled.p`
  font-family: Flow-Inverted;
  font-size: 4.9em;
  line-height: 1.3;
  padding: 0 ${em(3, 4.9)};
  
  
  @media (max-width: 1920px) {
    font-size: ${49/(1920*0.01)}vw;
  }
  
  @media (max-width: 1200px) {
    font-size: ${49/(1200*0.01)}vw;
  }
  
  @media (max-width: 670px) {
    font-size: 2.8em;
  }
  
  @media (max-width: 440px) {
    font-size: 2em;
    font-family: Flow-Text;
  }
`;

const ReviewAuthor = styled.span`
  font-family: Flow-Inverted;
  display: block;
  font-size: 4.9em;
  line-height: 1.3;
  margin-top: ${em(5.4, 4.9)};
  margin-bottom: ${em(5, 4.9)};
  
  @media (max-width: 1920px) {
    font-size: ${49/(1920*0.01)}vw;
    margin-top: ${54/(1920*0.01)}vw;
  } 
  
  @media (max-width: 1200px) {
    font-size: ${49/(1200*0.01)}vw;
    margin-top: ${54/(1200*0.01)}vw;
  }
  
  @media (max-width: 670px) {
    font-size: 2.8em;
  }
`;

interface Review {
  author: string;
  excerpt: string;
}

interface Props {
  reviews?: {
    title?: string;
    festival_reviews?: Review[];
  }
}

const ReviewsLift = ({
  reviews,
}: Props) => {
  const {
    title,
    festival_reviews,
  } = reviews;

  const reviewCarouselSettings = {
    dots: festival_reviews && festival_reviews.length > 1,
    arrows: false,
    autoplay: festival_reviews && festival_reviews.length > 1
  };

  return (
    <div>
      {Boolean(title) && <SectionTitle title={title}/>}
      <Carousel>
        { festival_reviews &&
          <SimpleCarousel settings={reviewCarouselSettings}>
            {festival_reviews.map((review: Review, index: number) =>
              <div key={index}>
                <ReviewContent>
                  <ReviewText>{review.excerpt}</ReviewText>
                  <ReviewAuthor>{review.author}</ReviewAuthor>
                </ReviewContent>
              </div>
            )}
          </SimpleCarousel>
        }
      </Carousel>
    </div>
  )
};

export default ReviewsLift;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/home/components/reviews-lift/ReviewsLift.tsx